import { HTMLAttributes, ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useStyles } from './not-fitted-user-modal.styles';
import { Modal, ResponsiveWidth } from '../../../../common';
import { INotFittedUserModalProps } from './not-fitted-user-modal.models';
import { InternalLinks } from '../../../../../constants';
import { Button } from '../../../../common/button-new';

export const NotFittedUserModal = ({ updateAppointments, onNavigate, onClose, ...props }: INotFittedUserModalProps): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  const handleButtonClick = async () => {
    onNavigate(`${InternalLinks.ecpLocator}?ecpService=fit`);
  };

  return (
    <Modal
      {...props}
      onClose={onClose}
      data-testid="not-fitted-user-modal"
      responsiveWidth={ResponsiveWidth.mdWide}
      PaperProps={{ 'data-testid': 'not-fitted-user-content' } as HTMLAttributes<HTMLDivElement>}
      title={intl.formatMessage({ id: 'order.notFittedUser.modal.title' }, { sup: (chunks: ReactNode) => <sup>{chunks}</sup> })}
      titleStyles={classes.title}
      content={(
        <>
          <p
            className={classes.description}
            data-testid="not-fitted-user-modal-description"
          >
            <FormattedMessage id="order.notFittedUser.modal.description" />
          </p>
          <div className={classes.actions}>
            <Button
              style="dark"
              onClick={handleButtonClick}
              testId="ecp-button"
            >
              <FormattedMessage id="order.notFittedUser.modal.button" />
            </Button>
            <Button
              style="outlined"
              onClick={() => onClose!()}
              testId="cancel-button"
            >
              <FormattedMessage id="common.cancelButton.label" />
            </Button>
          </div>
        </>
      )}
    />
  );
};
